import Navigation from "@/components/aoria/Navigation";
import Footer from "@/components/aoria/Footer";
import useReveal from "@/hooks/useReveal";
import { useEffect } from "react";

/**
 * Shared layout for sub-pages (legal, articles).
 * Wraps content with the same sticky nav and dark footer as the homepage.
 */
export default function PageLayout({ children, testid }) {
    useReveal();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, []);

    return (
        <div
            data-testid={testid || "page-layout"}
            className="bg-[#FDFDFC] text-[#1B263B] min-h-screen flex flex-col"
        >
            <Navigation />
            <main className="flex-1 pt-32 md:pt-40">{children}</main>
            <Footer />
        </div>
    );
}
